<section>
  <div class="mt-5 relative">
    <div
      class="w-full bg-[#285CA5] h-[124px] rounded-t-xl flex items-center justify-end"
    ></div>

    <div class="w-full h-[124px] flex items-center">
      <div class=" flex items-start justify-between w-full">
        <div>
          <div class="flex items-center space-x-3">
            <p class="text-2xl font-bold m-0 text-[#000000A6]">
              {{ client?.guardianName
              }}<span class="text-[#526ED3] text-base font-medium">
                {{ clientIdentifier }}</span
              >
            </p>
          </div>
          <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">
            {{ clientOnboardingLabel }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
      <img
        class="object-cover w-full h-full rounded-full"
        src="{{ client?.profilePic }} "
        alt=""
      />
    </div> -->
  </div>
  <tui-tabs [(activeItemIndex)]="activeItemIndex" class="gap-5">
    <button tuiTab type="button">My Profile</button>
    <!-- Security tab is only actionable for Registered clients (they have an
         email/password). Kept in the DOM at index 1 to preserve the existing
         section indexes, but disabled and visually muted for Inward and
         Unregistered clients which have no login flow. -->
    <button
      tuiTab
      type="button"
      [disabled]="!isRegistered"
      [style.opacity]="isRegistered ? null : 0.4"
      [title]="isRegistered ? '' : 'Security is only available for Registered clients'"
    >
      Security
    </button>
    <button tuiTab type="button">Shifts</button>
    <button tuiTab type="button">Charges</button>
  </tui-tabs>

  <div class="mt-10" *ngIf="activeItemIndex === 0">
    <!-- Personal Information block - branches on clientType so Unregistered
         and Inward clients show the fields actually captured for them. -->
   <div class="flex mb-10">
      <!-- Sidebar Label -->
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Client Information</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Client information</p>
      </div>

      <!-- Data Column -->
      <div class="flex-1 space-y-6">
        <!-- Registered Clients -->
        <ng-container *ngIf="isRegistered">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Registration Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ clientIdentifier || '-' }}</p>
          </div>
          <div *ngIf="client?.registrationDate">
            <p class="text-sm text-[#595959] font-medium m-0">Registration Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.registrationDate | date : "MMM d, y") || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Registration Type</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.registrationType || '-' }}</p>
          </div>
          <div *ngIf="client?.registrationFee !== null && client?.registrationFee !== undefined">
            <p class="text-sm text-[#595959] font-medium m-0">Registration Fee</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">LKR {{ client?.registrationFee | number : "1.2-2" }}</p>
          </div>
          <ng-container *ngIf="client?.registrationType && client?.registrationType !== 'Life Time' && client?.expiryDate">
            <div *ngIf="client?.renewalDate">
              <p class="text-sm text-[#595959] font-medium m-0">Renewal Date</p>
              <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">
                {{ (client?.renewalDate | date : "MMM d, y") || "—" }}
              </p>
            </div>
            <div>
              <p class="text-sm text-[#595959] font-medium m-0">Expiry Date</p>
              <p class="text-xl font-semibold m-0">
                {{ (client?.expiryDate | date : "MMM d, y") || "—" }}
              </p>
            </div>
          </ng-container>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Client Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianName || '-' }}</p>
          </div>
          <div *ngIf="client?.email">
            <p class="text-sm text-[#595959] font-medium m-0">Email Address</p>
            <p class="text-[#285CA5] text-xl font-bold m-0">{{ client?.email }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#285CA5] text-xl font-semibold m-0">{{ client?.guardianContactNo || '-' }}</p>
          </div>
          <div *ngIf="client?.guardianNIC">
            <p class="text-sm text-[#595959] font-medium m-0">NIC Number</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.guardianNIC }}</p>
          </div>
          <div *ngIf="client?.guardianAddress">
            <p class="text-sm text-[#595959] font-medium m-0">Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianAddress }}</p>
          </div>
        </ng-container>

        <!-- Unregistered Clients -->
        <ng-container *ngIf="isUnregistered">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Non Registered Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ clientIdentifier || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Starting Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.startingDate | date : "MMM d, y") || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Client Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianName || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Email Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.email || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianContactNo || '-' }}</p>
          </div>
          <div *ngIf="client?.guardianNIC">
            <p class="text-sm text-[#595959] font-medium m-0">NIC Number</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.guardianNIC }}</p>
          </div>
          <div *ngIf="client?.guardianAddress">
            <p class="text-sm text-[#595959] font-medium m-0">Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianAddress }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Nursing Type</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.nursingType || '-' }}</p>
          </div>
        </ng-container>

        <!-- Inward Clients -->
        <ng-container *ngIf="isInward">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">BHT Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ clientIdentifier || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianContactNo || "-" }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.inwardDate | date : "MMM d, y") || "-" }}</p>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- PATIENT INFORMATION SECTION -->
    <div class="flex mb-10">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Patient Information</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Patient Information</p>
      </div>

      <div class="flex-1 space-y-6">
        <div>
          <p class="text-sm text-[#595959] font-medium m-0">Name</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.name || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Room Number</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.roomNumber || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Meal Type</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.meal || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Roster</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.roster || '-' }}</p>
        </div>
        <div *ngIf="!isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Date of Birth</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.dateOfBirth | date : "MMM d, y") || '-' }}</p>
        </div>
        <div *ngIf="!isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Age</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ formatAge(client) }}</p>
        </div>
      </div>
    </div>

    <!-- CURRENT CONDITION SECTION -->
    <div class="flex mb-10" *ngIf="isRegistered || isUnregistered">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Current Condition</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Condition</p>
      </div>
      <div class="flex-1">
        <div style="background-color: white; border: 1px solid rgb(197, 194, 194); padding: 10px; border-radius: 8px;">
          <p class="text-[0.938rem] text-[#1B1F3BA6] font-medium m-0 leading-relaxed">
            {{ client?.currentCondition || '-' }}
          </p>
        </div>
      </div>
    </div>

    <!-- CURRENT LOCATION SECTION -->
    <div class="flex mb-10" *ngIf="isRegistered || isUnregistered">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Current Location</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View the patient location</p>
      </div>
      <div class="flex-1">
        <div style="background-color: white; border: 1px solid rgb(197, 194, 194); padding: 10px; border-radius: 8px;">
          <p class="text-[0.938rem] text-[#1B1F3BA6] font-medium m-0 leading-relaxed">
            {{ client?.currentLocation || '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 1">
    <form [formGroup]="changePasswordForm" (ngSubmit)="submitChangePassword()">
      <div class="flex">
        <div>
          <p class="text-base font-medium text-[#3E4A58] my-0">
            Client Information
          </p>
          <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">
            Change password
          </p>
        </div>
        <div class="w-full xl:w-1/3 2xl:w-1/3 pl-[6rem]">
          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="oldPassword">
              Old Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="oldPassword"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="password">
              New Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="password"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="confirmPassword">
              Confirm Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="confirmPassword"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <div class="mt-5 space-x-5 flex justify-end">
            <button
              tuiButton
              [disabled]="isLoading"
              appearance="primary"
              size="m"
              type="submit"
            >
              Update Password
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="mt-10" *ngIf="activeItemIndex === 2">
    <search
      class="lg:w-[50%] xl:w-[50%] 2xl:w-[40%] mb-5"
      tuiSearch
      style="padding-left: 0"
    >
      <fieldset
        class="border-none"
        tuiTextfieldSize="m"
        style="padding-left: 0"
      >
        <div class="flex items-center space-x-4">
          <div class="w-[431px]">
            <tui-input-date-range
              [(ngModel)]="dateRange"
              tuiUnfinishedValidator="Finish filling the field"
            >
              Date range filter
            </tui-input-date-range>
          </div>
          <button
  tuiButton
  type="button"
  size="m"
  (click)="onFilter()"
  style="padding: 0 50px; height: 44px; min-height: 54px;"
>
  Filter
</button>

<button
  tuiButton
  type="button"
  appearance="outline"
  (click)="resetFilter()"
  style="padding: 0 20px; height: 44px; min-height: 54px;"
>
  Reset Filter
</button>
        </div>
      </fieldset>
    </search>
    <div *ngIf="shifts.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">
        Attendance Unavailable!
      </p>
    </div>
    <div class="flex">
      <div *ngIf="shifts.length > 0" class="w-full">
        <table tuiTable size="m" class="w-full">
          <thead>
            <tr></tr>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Date
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Nurse name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Roster
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Meal Option
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Type
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Address
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Charges
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let shift of shifts">
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ getFormattedDate(shift.date) }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.nurse[0].name }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.rooster }} Hour
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.mealOption }}</p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.shiftType }}</p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{
                      (shift.address?.length || 0) > 20
                        ? (shift.address | slice : 0 : 40) + "..."
                        : shift.address
                    }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    LKR {{ shift.charges | number : "1.2-2" }}
                  </p>
                </div>
              </td>
             
            </tr>
          </tbody>
        </table>
        <div class="flex justify-end items-center mt-5">
          <tui-pagination
            [index]="shiftPageIndex - 1"
            [length]="getShiftPageCount()"
            (indexChange)="onShiftPageChange($event + 1)"
          >
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 3">
    <div *ngIf="chargesRecords.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">Charges Unavailable!</p>
    </div>

    <div *ngIf="chargesRecords.length > 0" class="flex">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table
          tuiTable
          size="m"
          class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]"
        >
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Month
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                No of Shifts
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Charges
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let chargesRecord of chargesRecords">
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ chargesRecord.monthName}} - {{ chargesRecord.year }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ chargesRecord.shifts.length }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ chargesRecord.totalCharges | number : "1.2-2" }} LKR
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p
                    class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
                    (click)="
                      viewChargesDetails(
                        clientId,
                        chargesRecord.month,
                        chargesRecord.year
                      )
                    "
                  >
                    
                    View Details
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="flex justify-start items-center mt-5 ml-[300px] md:ml-[570px] lg:ml-[450px] xl:ml-[690px] 2xl:ml-[970px]"
        >
          <tui-pagination
            [index]="chargesPageIndex - 1"
            [length]="getChargesPageCount()"
            (indexChange)="onChargesPageChange($event + 1)"
          >
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>
</section>
